<template lang="html">
    <div class="side-chat-footer">
        <div class="chat-send-group">
            <div class="chat-send file" id="send-file-button" @click="openFilePicker">
                <i class="fas fa-plus"></i>
            </div>
            <div class="chat-input-message">
                <textarea id="message-textarea" @keydown.enter="sendMessage" v-model="inputMessage"></textarea>
            </div>
            <div class="chat-send message">
                <i class="fas fa-paper-plane" @click="sendMessage"></i>
            </div>
        </div>
    </div>
</template>

<script>
import config from '@/config'

export default {
  data(){
    return {
      inputMessage: ""
    }
  },
  methods: {
    sendMessage: function(){
        if(this.inputMessage != "")
        {
        //1.Emit vuejs event to parent
          this.$emit('message:new', this.inputMessage);
        //2.Emit socketio event
        //3.Clear input field
          this.inputMessage = "";
        }
    },
    openFilePicker(){
      const client = filestack.init(config.FILESTACK_KEY);
      
      let sourceArray = [['local_file_system', 'instagram', 'facebook'], ['instagram', 'local_file_system', 'facebook'], ['facebook', 'instagram', 'local_file_system']];
      const options = {
        onUploadDone: response => {
            console.log(response);
            let filesUploaded = response.filesUploaded;
            let uploadedFilesArray = []; //processed files;

            filesUploaded.forEach((file) => {
                var fileData = new Object();
                fileData.name = file.filename;
                fileData.url = file.url;
                fileData.handle = file.handle;
                fileData.type = file.mimetype;
                fileData.size = file.size;
                uploadedFilesArray.push(fileData);
            });

            this.$emit('message:files', uploadedFilesArray);
        },
        accept: ["image/*", ".pdf", "text/*", "video/*"], //to be added: video, pdf, txt, doc
        fromSources: sourceArray[0],
      }

      client.picker(options).open();
    },
  },
  mounted(){
    //Filestack API
    let filestackScript = document.createElement('script')
    filestackScript.setAttribute('src', '//static.filestackapi.com/filestack-js/3.x.x/filestack.min.js')
    document.head.appendChild(filestackScript)
  }
}
</script>
